<template>
  <div class="managerDeliveryOrderView">
    <view-frame v-if="custName" :titleObject="titleObject" :buttonObj="buttonObj">
      <template #rightBtn>
        <el-button type="primary" size="mini" @click="handleEditClick">{{ $t('text.edit') }}</el-button>
      </template>
      <template>
        <el-card>
          <el-row>
            <el-col :span="24">
              <span class="view__text">{{ $t('text.basicInfo') }}</span>
              <el-card class="animate__animated animate__fadeInDown" shadow="hover">
                <custome-table tableType="object" :custSpan="6" :data="custName.basic_information" :dataItem="productBasicViewItem" @forwardToPage="handleBasicInfoForwardToPage" ></custome-table>
              </el-card>
            </el-col>
          </el-row>
          <el-row v-if="custName && custName.images.length > 0" class="margintop20" :gutter="20">
            <el-col :span="24" :gutter="20">
              <span class="view__text">{{ $t('text.image') }}</span>
              <el-card class="animate__animated animate__fadeInDown" shadow="hover">
                <createTable :autoWidth="true" :tableDataItem="imagesViewItem" :operateVisible="false" :tableData="custName.images"></createTable>
              </el-card>
            </el-col>
          </el-row>
          <el-row v-if="custName && custName.shop_item_stocks.length > 0" class="margintop20" :gutter="20">
            <el-col :span="24" :gutter="20">
              <span class="view__text">{{ $t('form.product.commodityInventory') }}</span>
              <el-card class="animate__animated animate__fadeInDown" shadow="hover">
                <createTable
                  :autoWidth="true"
                  :tableDataItem="shopItemStocksViewItem"
                  :operateVisible="true"
                  :tableData="custName.shop_item_stocks"
                  @forwardToPage="handleShopItemStocksTableForwardToPage"
                  @onSwitchChange="handleCreateTableSwitchChange"
                  :operationColWidth="200"
                >
                  <template #rightBtn="scope">
                    <el-button
                      class="margintop10"
                      :class="item.action === 'view' ? 'operate_view' : ''"
                      v-for="(item, index) in scope.row.member_actions.default_actions"
                      :key="'default_actions' + index"
                      :type="item.type && item.type === 'warn' ? 'danger' : 'primary'"
                      size="mini"
                      @click="handleVariationsClick(item, scope.row)"
                      >{{ item.name }}</el-button
                    >
                    <el-button
                      class="margintop10"
                      v-for="(item, index) in scope.row.member_actions.custom_actions"
                      :key="'custom_actions' + index"
                      :type="item.type && item.type === 'warn' ? 'danger' : 'primary'"
                      size="mini"
                      @click="handleCusClick(item)"
                      >{{ item.name }}</el-button
                    >
                  </template>
                </createTable>
              </el-card>
            </el-col>
          </el-row>
          <el-row v-if="custName && custName.shop_sub_categories.length > 0" class="margintop20" :gutter="20">
            <el-col :span="24" :gutter="20">
              <span class="view__text">{{ $t('form.product.shopSubCategories') }}</span>
              <el-card class="animate__animated animate__fadeInDown" shadow="hover">
                <createTable
                  :autoWidth="true"
                  :tableDataItem="shopSubCategoriesViewItem"
                  :operateVisible="false"
                  :tableData="custName.shop_sub_categories"
                ></createTable>
              </el-card>
            </el-col>
          </el-row>
          <el-card class="margintop20">
            <el-row>
              <el-col :span="24">
                <span class="view__text">{{ $t('form.common.changeHistory') }}</span>
                <el-card class="animate__animated animate__fadeInUp" shadow="hover">
                  <span class="view__text"></span>
                  <historyTable
                    :tableDataItem="historyTableItem"
                    itemType="ShopItem"
                    :itemId="urlParams.id"
                  />
                </el-card>
              </el-col>
            </el-row>
          </el-card>
        </el-card>
      </template>
    </view-frame>
    <dialogEffect v-if="dialogVisible" :dialogVisible.sync="dialogVisible" :data="dialogData" @doNextConfirm="doNextConfirm"></dialogEffect>
  </div>
</template>

<script>
import Logic from './index.js'
export default Logic
</script>

<style lang="scss" scope>
@import './index.scss';
</style>
